module.exports = __webpack_public_path__ + "static/media/iconDown.ddd459ae.svg";